import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    // errorTexts.ts — по коду отказа
    notAuthor: 'Нет прав на этот курс или статью',
    notAdmin: 'Доступно только админу',
    invalidBlock: 'Данные блока заполнены неверно',
    blockNotAllowed: 'Этот тип блока нельзя добавить в этот урок',
    jobInProgress: (job: string) => `Идёт ${job} — дождитесь окончания`,
    draftCourse: 'Курс обновился — обновите страницу',
    trialLessonsLimit: 'Бесплатных уроков не больше трёх и меньше, чем уроков в курсе',
    mascotsLimit: 'Одно место под маскота на каждые 3 урока',
    articleInUse: 'Статья используется в курсах. Отвяжите её сначала.',
    articleNotPublished: 'Статья ещё не опубликована.',
    notPublished: 'Это ещё не опубликовано.',
    published: 'Снимите с публикации перед удалением.',
    categoryInUse: 'Нельзя удалить — категория используется',
    // errorTexts.ts — по статусу
    status400: 'Не получилось выполнить действие. Проверьте данные и попробуйте ещё раз.',
    status403: 'Нет прав на это действие.',
    status404: 'Не нашли то, что вы искали. Возможно, это уже удалили.',
    status409: 'Не удалось сохранить: данные конфликтуют. Попробуйте ещё раз',
    server: 'Сервер не отвечает. Попробуйте ещё раз через минуту.',
    // errorTexts.ts — валидация
    categoryKindMismatch: 'Категория не подходит для этого типа контента',
    fieldTooLongMax: (field: string, max: number) => `Поле «${field}» длиннее ${max} символов`,
    fieldTooLong: (field: string) => `Поле «${field}» слишком длинное`,
    // errorToastMiddleware.ts
    network: 'Нет соединения с сервером. Проверьте интернет и попробуйте ещё раз.',
    // lib/requestId.ts — ID запроса в тосте общей ошибки
    requestId: (id: string) => `ID запроса: ${id}`,
    requestIdCopy: 'Скопировать',
    requestIdCopied: 'ID скопирован',
    requestIdCopyFailed: 'Не удалось скопировать ID',
  },
  en: {
    notAuthor: 'You don’t have access to this course or article',
    notAdmin: 'Available to admins only',
    invalidBlock: 'Some block fields are filled in incorrectly',
    blockNotAllowed: 'This block type can’t be added to this lesson',
    jobInProgress: (job: string) =>
      `${job.charAt(0).toUpperCase()}${job.slice(1)} in progress — wait until it finishes`,
    draftCourse: 'The course was updated — refresh the page',
    trialLessonsLimit:
      'Up to three free lessons, and fewer than the total number of lessons in the course',
    mascotsLimit: 'One mascot slot per 3 lessons',
    articleInUse: 'This article is used in courses. Unlink it first.',
    articleNotPublished: 'The article isn’t published yet.',
    notPublished: 'This isn’t published yet.',
    published: 'Unpublish it before deleting.',
    categoryInUse: 'Can’t delete — the category is in use',
    status400: 'Couldn’t complete the action. Check the data and try again.',
    status403: 'You don’t have permission for this action.',
    status404: 'We couldn’t find what you were looking for. It may have been deleted.',
    status409: 'Couldn’t save because of a data conflict. Try again.',
    server: 'The server isn’t responding. Try again in a minute.',
    categoryKindMismatch: 'This category doesn’t apply to this content type',
    fieldTooLongMax: (field: string, max: number) =>
      `The “${field}” field is longer than ${max} characters`,
    fieldTooLong: (field: string) => `The “${field}” field is too long`,
    network: 'No connection to the server. Check your internet and try again.',
    requestId: (id: string) => `Request ID: ${id}`,
    requestIdCopy: 'Copy',
    requestIdCopied: 'ID copied',
    requestIdCopyFailed: 'Couldn’t copy the ID',
  },
})
